import { useEffect, useState } from 'react';
import { Image } from 'react-native';

/**
 * Proporção real (largura / altura) de uma imagem.
 *
 * O logo é enviado por cada cliente, então a proporção não é conhecida em build
 * time. Com uma caixa de tamanho fixo o `resizeMode="contain"` centraliza a arte
 * e deixa faixas vazias nas laterais — é isso que fazia a margem VISUAL do logo
 * ficar maior que a dos demais ícones do header, mesmo com o mesmo padding.
 *
 * Enquanto a medida não chega (ou se falhar), vale o `fallback`.
 */
export function useImageAspectRatio(source, fallback = 1) {
  const [ratio, setRatio] = useState(fallback);

  useEffect(() => {
    let active = true;
    setRatio(fallback);

    if (!source) return;

    const uri =
      typeof source === 'string'
        ? source
        : source?.uri || Image.resolveAssetSource?.(source)?.uri;

    if (!uri) return;

    Image.getSize(
      uri,
      (width, height) => {
        if (active && width > 0 && height > 0) setRatio(width / height);
      },
      // Falha ao medir (CORS, 404, imagem local sem uri) mantém o fallback.
      () => {}
    );

    return () => {
      active = false;
    };
  }, [source, fallback]);

  return ratio;
}

export default useImageAspectRatio;
